import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const CronoSearchBarWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${colors.grey444};
  transition: color 0.2s;

  .search-icon path {
    stroke: ${colors.grey11};
    transition: stroke 0.2s;
  }

  .search-text-field .MuiInputBase-input {
    color: ${colors.grey11};
    transition: color 0.2s;
  }
  .search-text-field .MuiInputBase-input::placeholder {
    color: ${colors.grey11};
    opacity: 1;
    transition: color 0.2s;
  }

  &:hover,
  &:focus-within {
    /* icon */
    .search-icon path {
      stroke: ${colors.grey1};
    }
    .search-text-field .MuiInputBase-input {
      color: ${colors.grey1};
    }
    .search-text-field .MuiInputBase-input::placeholder {
      color: ${colors.grey1};
    }
  }

  .remove-text-icon {
    cursor: pointer;
  }

  .search-text-field {
    padding: 0px 10px;
    width: 100%;
  }
`;
